'use client'
import React from 'react'
import { ClearIcon } from '../../../icons'
import { ClearIndicatorProps, GroupBase } from 'react-select'
import { SelectOption } from '../../../../types/SelectInput'
import { data_click_outside_safe } from '../../../../hooks/useOutsideClick'

export const ClearIndicatorReplacement = (
    props: ClearIndicatorProps<SelectOption, boolean, GroupBase<SelectOption>>,
) => {
    const {
        children,
        innerProps: { ref, ...restInnerProps },
    } = props
    return (
        <div
            {...restInnerProps}
            ref={ref}
            className="w-10 h-full inline-flex items-center justify-center text-accent-700 border-transparent hover:bg-accent-opacity-100 active:bg-accent-opacity-100 active:shadow-inner-md focus:bg-accent-opacity-100 focus:border-accent-600 cursor-pointer"
            role="button"
            data-testid="select-input-clear-button"
            {...data_click_outside_safe}
        >
            <ClearIcon />
            {children}
        </div>
    )
}
